const skills = {
  "Languages": [
    { name: "Python", level: "advanced" },
    { name: "JavaScript", level: "advanced" },
    { name: "Scala", level: "intermediate" },
    { name: "TypeScript", level: "intermediate" },
    { name: "SQL", level: "advanced" },
    { name: "Bash", level: "intermediate" }
  ],
  "Web & APIs": [
    { name: "FastAPI", level: "advanced" },
    { name: "ReactJS", level: "advanced" },
    { name: "Node.js", level: "intermediate" },
    { name: "REST APIs", level: "advanced" },
    { name: "OAuth 2.0", level: "intermediate" }
  ],
  "Databases": [
    { name: "MongoDB", level: "intermediate" },
    { name: "PostgreSQL", level: "intermediate" },
    { name: "MySQL", level: "intermediate" },
    { name: "ChromaDB", level: "intermediate" },
    { name: "Neo4j", level: "intermediate" }
  ],
  "Distributed Systems": [
    { name: "Apache Spark", level: "intermediate" },
    { name: "Apache Flink", level: "intermediate" },
    { name: "Hadoop MapReduce", level: "intermediate" },
    { name: "Parquet", level: "intermediate" },
    { name: "HDFS", level: "intermediate" }
  ],
  "Machine Learning": [
    { name: "PyTorch", level: "intermediate" },
    { name: "TensorFlow", level: "intermediate" },
    { name: "scikit-learn", level: "intermediate" },
    { name: "Pandas", level: "advanced" },
    { name: "NumPy", level: "advanced" },
    { name: "RAG", level: "intermediate" },
    { name: "LangChain", level: "intermediate" },
    { name: "Ollama", level: "intermediate" },
    { name: "LoRA Fine-tuning", level: "intermediate" },
    { name: "LLM Training", level: "intermediate" }
  ],
  "Cloud": [
    { name: "AWS (S3, EMR, EC2, IAM, VPC, EKS)", level: "intermediate" },
    { name: "Google Cloud (Cloud Run)", level: "intermediate" }
  ],
  "DevOps & Tools": [
    { name: "Git", level: "advanced" },
    { name: "Docker", level: "intermediate" },
    { name: "Kubernetes", level: "intermediate" },
    { name: "CI/CD", level: "intermediate" },
    { name: "Playwright", level: "intermediate" },
    { name: "GTK4", level: "beginner" },
    { name: "OWASP ZAP", level: "beginner" },
    { name: "Linux", level: "intermediate" },
    { name: "Prometheus", level: "intermediate" },
    { name: "Grafana", level: "intermediate" }
  ]
};

export default skills;
